import { hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// SSG: the HTML inside #root is prerendered by scripts/prerender.mjs.
// hydrateRoot attaches event handlers without redrawing the DOM.
hydrateRoot(document.getElementById("root")!, <App />);
